import log from 'loglevel';
import React from 'react';
import { usePlayerContext } from '../Context';
import ReactDOM from 'react-dom/client';
import PluginInterface from '../../sdk/plugins/PluginInterface';

const PluginControlContainer = (props: {
  full?: boolean;
  pluginName: string;
  controlName: string;
  plugin: PluginInterface;
}) => {
  const { sdk } = usePlayerContext();

  const prefix = sdk.getClassNamePrefix();
  const { pluginName, controlName, plugin, full } = props;

  //@ts-ignore
  let ThePluginControl = plugin.getControls()[controlName];
  log.debug('ThePluginControl', plugin, ThePluginControl);
  if (full === true) return <ThePluginControl sdk={sdk} plugin={plugin} React={React} />;
  return (
    <div
      className={`${prefix}-player-control ${sdk.getClassNamePrefix()}-player-control-plugin-${pluginName}-${controlName}`}
      onClick={() => {
        sdk.clickControl(controlName);
      }}
    >
      <ThePluginControl sdk={sdk} plugin={plugin} React={React} />
    </div>
  );
};

export default PluginControlContainer;
